import Ext from 'Ext'
import UsersSelectorPanel from '../usersSelector/at_users_selector_panel'
import SwitcherWithWrapper from '../components/SwitcherWithWrapper'
import $ from 'jquery'
import messageResource from '../messageResource'
import ReportsUsersSelectorFilter from './ReportsUsersSelectorFilter'
import ReportsUserSelectorTreeBuilderObserver from './ReportsUserSelectorTreeBuilderObserver'
import {disableTextSelection} from '../atBrowserUtils'

const ShareReportsSelectorUsersPanel = Ext.extend(UsersSelectorPanel, {
    showInactiveLabelKey: 'users_selector.reports.show_disabled',
    predefinedState: null,
    hasPanel: true,
    resetOnHide: true,
    allUsersAvailable: true,
    loggedInUserNotInTeam: false,
    allItemsOptionValue: false,

    setSelectorFilter() {
        this.selectorFilter = new ReportsUsersSelectorFilter({
            tree: this.selectorTree,
            searchIndex: this.searchIndex,
            allActiveSet: this.allActiveSet,
            myTeamNodesSet: this.treeBuilderObserver.getManageableUsersNodeSet(),
            accessibleParentNodes: this.treeBuilderObserver.getAccessibleParentNodes(),
            showTeamOnly: this.showTeamOnly
        })
    },

    createUserSelectorTreeBuilderObserver(searchIndex, allActiveSet) {
        this.treeBuilderObserver = new ReportsUserSelectorTreeBuilderObserver({
            searchIndex,
            allActiveSet,
            manageableUsersIdsSet: this.manageableUsersIdsSet
        })
        return this.treeBuilderObserver
    },

    initialize({userGroupsEnabled, timeZoneGroupsEnabled, users, manageableUsersIds, userGroups, timeZoneGroups, showTeamOnly, loggedInUserNotInTeam}) {
        const state = this.predefinedState
        this.manageableUsersIdsSet = manageableUsersIds && manageableUsersIds.length > 0 ? new Set(manageableUsersIds) : null
        this.loggedInUserNotInTeam = loggedInUserNotInTeam

        if (!state.optionValue && !state.showInactive) {
            const selectedUserIds = state.selection.getSecondLevel()

            for (let i = 0; i < users.length; i++) {
                if (selectedUserIds.indexOf(users[i].id) !== -1) {
                    if (!users[i].active) {
                        state.showInactive = true
                        break
                    }
                }
            }
        }

        ShareReportsSelectorUsersPanel.superclass.initialize.call(this, userGroupsEnabled, timeZoneGroupsEnabled, users, userGroups, timeZoneGroups)

        this.showTeamOnly = showTeamOnly
        this.showTeamOnlyInit = showTeamOnly
        this.alreadyShown = false
        this.clearPanel()

        this.loadState(state)

        this.selectorFilter.setShowInactive(state.showInactive)
    },

    createCustomOption() {
        this.customOption = undefined
    },

    createGenericOptions() {
        this.genericOptions = []
    },

    disableTextSelectionForNeededElements() {
        disableTextSelection(this.customOptionsContainer.el.dom)
    },

    getCurrentOptionValue() {
        return this.customOptionValue
    },

    isCustomOptionSelected() {
        return true
    },

    getCustomOptionSection() {
        const customOptionControls = []
        // from left to right
        customOptionControls.push(this.viewByPanel)
        customOptionControls.push(this.getCustomOptionButtonsSection())

        this.customControlsContainer = new Ext.Container({
            cls: 'userSelectorCustomControlsContainer',
            autoEl: 'div',
            items: customOptionControls
        })
        return [this.mainLabel, this.customControlsContainer]
    },

    getDetailsSection() {
        return [this.selectorTree]
    },

    getDescription(selectionHelper, dropdownButtonId) {
        return messageResource.getMessage('saved_reports.common.copy_to')
    },

    setPredefinedState(predefinedState) {
        this.predefinedState = predefinedState
    },

    createComponents() {
        ShareReportsSelectorUsersPanel.superclass.createComponents.call(this)

        this.mainLabel = new Ext.Panel({
            html: messageResource.getMessage('saved_reports.common.user_selector.copy_report_config_to'),
            cls: 'text main-label'
        })

        this.on('afterlayout', () => {
            if (this._isTeamOnlySwitcherAvailable()) {
                const $container = $(this.el.dom).find('.custom')
                const switcherText = messageResource.getMessage('saved_reports.common.user_selector.copy_report_team_switcher')
                this.showTeamOnlySwither = new SwitcherWithWrapper({
                    containerAdditionalClass: 'teamSwitcherContainer',
                    switcherTextAdditionalClass: 'teamSwitcherText',
                    switcherAdditionalClass: 'teamSwitcher',
                    onSwitchCallback: show => this._teamSwitchedHandler(show),
                    switcherText: switcherText,
                }).init($container)
                this.showTeamOnlySwither.setState({enabled: this.showTeamOnly})
            }
        })

        this.addClass('shareConfigUserSelectorPanel')
    },

    _isTeamOnlySwitcherAvailable() {
        return this.manageableUsersIdsSet !== null && this.manageableUsersIdsSet.size !== this.users.length
    },

    _teamSwitchedHandler(show) {
        this.showTeamOnly = show
        this.showTeamOnlySwither.setState({enabled: show})
        this.selectorFilter.setShowUsersFromMyTeamOnly(show)
        this.onChange()
    },

    validateIsUsersSelected() {
        return !this.isCustomOptionSelected() || !this.getSelection().isEmpty()
    },

    makeSelectionTree() {
        //do nothing
    },

    setInitialValueFromCurrent() {
        if (this.isAlreadyShown()) {
            this.setFilterFlag(this.getShowInactive())
            this.selectorTree.initializeByNodeSet(this.makeNodeSet(this.getSelection()))
            this.setInitialOptionValue(!this.isCustomOptionSelected())
            this.updateInitialTreeSet()
            this.updateInitialGroupType()
            this.showTeamOnlyInit = this.showTeamOnly
        }
    },

    initComponent() {
        ShareReportsSelectorUsersPanel.superclass.initComponent.call(this)
        this.collapsedCookiesKey += 'CollapsedUsers'
        this.on('afterlayout', function() {
            const parentNode = this.getEl().findParentNode('div.at-selector-menu', 10, true)
            if (parentNode) parentNode.addClass('usersSelectorType')
        }, this)
    },

    isStateChanged() {
        if (this.isAlreadyShown()) {
            return ShareReportsSelectorUsersPanel.superclass.isStateChanged.call(this)
        } else {
            return false
        }
    },

    resetState(isEnableActiveActions) {
        if (this._isTeamOnlySwitcherAvailable()) {
            this._teamSwitchedHandler(this.showTeamOnlyInit)
        }

        ShareReportsSelectorUsersPanel.superclass.resetState.call(this, isEnableActiveActions)
    }
})

Ext.reg('at_reports_selector_users_panel', ShareReportsSelectorUsersPanel)

export default ShareReportsSelectorUsersPanel


// WEBPACK FOOTER //
// ./web/js/reports/ShareReportsSelectorUsersPanel.js